import type { BreakView } from "./types";

/** "0 min", "<1 min", "12 min", "1h 05m". "—" for an unknown value. */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds)) return "—";
  if (seconds === 0) return "0 min";
  if (seconds < 60) return "<1 min";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h === 0) return `${m} min`;
  return `${h}h ${String(m).padStart(2, "0")}m`;
}

/** Length of one break: like formatDuration, but anything under a minute is "<1 min". */
export function formatBreakLength(seconds: number | null | undefined): string {
  if (seconds !== null && seconds !== undefined && seconds < 60) return "<1 min";
  return formatDuration(seconds);
}

/** Live-timer form: "0:07", "12:07", "1:02:07". */
export function formatClock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(sec)}` : `${m}:${pad(sec)}`;
}

/** How a break ended, when that is worth showing. */
export function closedByLabel(b: Pick<BreakView, "open" | "closedBy">): string | null {
  if (b.open) return "In progress";
  if (b.closedBy === "checkout") return "Ended at check-out";
  if (b.closedBy === "checkin") return "Ended at next check-in";
  return null;
}
